import { render } from "./AddOkrButton.vue?vue&type=template&id=4ff06ead&scoped=true"
import script from "./AddOkrButton.vue?vue&type=script&lang=js"
export * from "./AddOkrButton.vue?vue&type=script&lang=js"

import "./AddOkrButton.vue?vue&type=style&index=0&id=4ff06ead&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff06ead"]])

export default __exports__